export var ENV = {
    LOGIN_URL: process.env.REACT_BASE_AUTH,
    REGISTER_PATIENT: process.env.REACT_REGISTER_PATIENT,
};
